/* eslint-disable @typescript-eslint/no-floating-promises */

'use client'

import { useEffect, useLayoutEffect, Suspense } from 'react'
import { initializeClientAnalytics } from '@utils/analyticsScript'
import { useEnvVariablesClientConfig } from '@context/EnvClientContext/EnvVariablesClientContext'
import { TENANT_TYPE } from '@components/Ackodrive/common/constants'
import { getConfig } from '@configs/envConfig'
import { getTrackerId } from '@utils/utils'
import { usePathname, useSearchParams } from 'next/navigation'
import { setUserVisit } from '@services/setUserVisit'
// import useInitGlobals from '@scripts/gtmScripts'

export const InitialiseAckoAnalyticsImpl = ({ tenant = TENANT_TYPE.ACKOSEO, cdpApiEndPoint = '' }) => {
  const pathName = usePathname()
  const queryParams = useSearchParams()
  const config = useEnvVariablesClientConfig()
  const currentEnv = config?.ACKO_ENV
  const SEGMENT_WRITE_KEY = getConfig(currentEnv)?.segmentKey?.[tenant]
  const trackerIdVal = getTrackerId(tenant)

  // Configure the committed tenant before page-view useEffects run, including client navigation.
  // Plain data assignment needs no inline script/nonce and cannot execute cookie-derived strings.
  useLayoutEffect(() => {
    if (trackerIdVal && currentEnv && SEGMENT_WRITE_KEY) {
      initializeClientAnalytics(trackerIdVal, SEGMENT_WRITE_KEY, cdpApiEndPoint || undefined)
    }
  }, [trackerIdVal, currentEnv, SEGMENT_WRITE_KEY, cdpApiEndPoint])

  useEffect(() => {
    if (tenant === TENANT_TYPE.HOMEPAGE && currentEnv) {
      ;(async () => {
        await setUserVisit(pathName, queryParams, currentEnv)
      })()
    }
  }, [currentEnv])

  return <div />
}

export const InitialiseAckoAnalytics = props => (
  <Suspense>
    <InitialiseAckoAnalyticsImpl {...props} />
  </Suspense>
)
